var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$route.query.page)?_c('infinite-list',{attrs:{"folder":_vm.folder}}):_vm._e(),(_vm.$route.query.page)?_c('list',{attrs:{"folder":_vm.folder,"pageId":_vm.$route.query.page,"entryList":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }